import { api } from "@/lib/api";

const MAX_BYTES = 100 * 1024 * 1024; // 100 MB
const CHUNK = 1024 * 1024; // 1 MB

// Upload a file to a client's document store in 1 MB chunks (bypasses gateway
// request-size limits). Returns the final completed file record.
export async function uploadClientFileChunked(clientId, file, docType) {
  if (!file) return null;
  if (file.size > MAX_BYTES) {
    const err = new Error("File is too large (max 100 MB).");
    err.userMessage = "File is too large (max 100 MB).";
    throw err;
  }
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let last = null;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK, (i + 1) * CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", i);
    fd.append("total_chunks", total);
    fd.append("filename", file.name);
    fd.append("content_type", file.type || "application/octet-stream");
    fd.append("doc_type", docType);
    fd.append("chunk", blob, file.name);
    const { data } = await api.post(`/clients/${clientId}/files/chunk`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (data.done) last = data;
  }
  return last;
}

// Trigger a browser download from a base64-encoded payload.
export function downloadBase64(b64, contentType, filename) {
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: contentType }));
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
